import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { AppShell } from './AppShell';
import { LoginPage } from '../pages/LoginPage';
import { DashboardPage } from '../pages/DashboardPage';
import { LedgerPage } from '../pages/LedgerPage';

const BillsPage = lazy(() => import('../pages/BillsPage').then((module) => ({ default: module.BillsPage })));
const ReportsPage = lazy(() => import('../pages/ReportsPage').then((module) => ({ default: module.ReportsPage })));
const SettingsPage = lazy(() => import('../pages/SettingsPage').then((module) => ({ default: module.SettingsPage })));
const ManagementPage = lazy(() => import('../pages/ManagementPage').then((module) => ({ default: module.ManagementPage })));
const RecurrencesPage = lazy(() => import('../pages/RecurrencesPage').then((module) => ({ default: module.RecurrencesPage })));
const ConflictsPage = lazy(() => import('../pages/ConflictsPage').then((module) => ({ default: module.ConflictsPage })));
const TrashPage = lazy(() => import('../pages/TrashPage').then((module) => ({ default: module.TrashPage })));
const TransactionPage = lazy(() => import('../pages/TransactionPage').then((module) => ({ default: module.TransactionPage })));

function RouteFallback() {
  return <div className="route-fallback" role="status">Abrindo…</div>;
}

export function AppRouter() {
  const { user, loading, error } = useAuth();
  if (loading) return <div className="app-loading"><span className="brand-mark">K</span><p>Preparando seus dados…</p></div>;
  if (error && !user) return <LoginPage initialError={error} />;
  if (!user) return <LoginPage />;

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="lancamentos" element={<LedgerPage />} />
        <Route path="lancamentos/:entityType/:entityId" element={<Suspense fallback={<RouteFallback />}><TransactionPage /></Suspense>} />
        <Route path="contas" element={<Suspense fallback={<RouteFallback />}><BillsPage /></Suspense>} />
        <Route path="recorrencias" element={<Suspense fallback={<RouteFallback />}><RecurrencesPage /></Suspense>} />
        <Route path="relatorios" element={<Suspense fallback={<RouteFallback />}><ReportsPage /></Suspense>} />
        <Route path="cadastros" element={<Suspense fallback={<RouteFallback />}><ManagementPage /></Suspense>} />
        <Route path="conflitos" element={<Suspense fallback={<RouteFallback />}><ConflictsPage /></Suspense>} />
        <Route path="lixeira" element={<Suspense fallback={<RouteFallback />}><TrashPage /></Suspense>} />
        <Route path="ajustes" element={<Suspense fallback={<RouteFallback />}><SettingsPage /></Suspense>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
